export default "__VITE_ASSET__DEt8bGaq__"